import styled from 'styled-components';

export const Container = styled.div``;

export const ShowPassword = styled.button`
	padding: 0;
	border: none;
	background: none;
	cursor: pointer;
	margin-left: 12px;
`;
